import router from '@/router'

//导入request工具
import request from '@/utils/request'

//导入cookies工具
import {
	getToken,
	setToken,
	removeToken,
	getUserInfo,
	setUserInfo,
	removeUserInfo
} from '@/utils/cookies'
import {
	ElMessage
} from 'element-plus'
//创建State模块,用于获取token 和 userInfo
const state = {
	token: getToken() || '',
	userInfo: getUserInfo() || {}
}

//创建Mutations模块,用于修改token 和 userInfo
const mutations = {
	SET_TOKEN(state, token) {
		state.token = token
		setToken(token)
	},
	SET_USER_INFO(state, userInfo) {
		state.userInfo = userInfo
		setUserInfo(userInfo)
	},
	LOGOUT(state) {
		state.token = ''
		state.userInfo = {}
		removeToken()
		removeUserInfo()
	}
}

//创建Actions模块,用于登录和退出
const actions = {
	async login({
		commit
	}, loginForm) {
		try {
			const res = await request.post('admin/employee/login', loginForm)
			if (res.code === 200) {
				const {
					token,
					...info
				} = res.data
				commit('SET_TOKEN', token)
				commit('SET_USER_INFO', info)
				console.log(res)
				ElMessage.success('登录成功')
				return res
			} else {
				ElMessage.error(res.msg || '登录失败')
				return Promise.reject(res.msg)
			}
		} catch (err) {
			console.log(err)
			ElMessage.error('登录异常，请稍后重试')
			return Promise.reject(err)
		}
	},
	logout({
		commit
	}) {
		commit('LOGOUT')
		ElMessage.success('退出成功')

	}
}

const getters = {
	token: (state) => state.token,
	userInfo: (state) => state.userInfo,
	name: (state) => state.userInfo.name,
	username: (state) => state.userInfo.userName || '游客'
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}